import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class LectureVotes extends Resource {
  public static type = 'lecture_votes';

  @prop
  public value: number;

  @prop
  public comment: string;

  @prop
  public lectureId: string;

  @prop
  public profileId: string;

  @prop
  public eventId: string;
}
